import { ApolloClient } from '@apollo/client';
import { useFeatureFlags } from '@hooks/LaunchDarkly/useFeatureFlags';
import CruiseSearchContextProvider from 'contexts/CruiseSearchContext';
import React, { useEffect, useState } from 'react';
import { ClientSideConfig } from 'types';

interface AppWrapperProps {
	initialState: unknown;
	apolloClient: ApolloClient<object>;
	config: ClientSideConfig;
}

const MAX_RETRIES = 20; // Wait for 2 seconds at most
const RETRY_INTERVAL = 100;

export const AppWrapper: React.FC<React.PropsWithChildren<AppWrapperProps>> = ({ children, apolloClient, config, initialState }) => {
	const flags = useFeatureFlags();
	const [retryAttempts, setRetryAttempts] = useState(1);

	useEffect(() => {
		if (Object.keys(flags).length === 0 && retryAttempts < MAX_RETRIES) {
			const timer = setTimeout(() => {
				setRetryAttempts((prev) => prev + 1);
			}, RETRY_INTERVAL);

			return () => clearTimeout(timer);
		}
	}, [flags, retryAttempts]);

	// Keep returning null and retrying if flags are empty and we haven't hit max retries
	if (Object.keys(flags).length === 0 && retryAttempts < MAX_RETRIES) {
		return null;
	}

	// After max retries or when flags are loaded, render the provider
	return (
		<CruiseSearchContextProvider apolloClient={apolloClient} config={config} initialState={initialState} flags={flags}>
			{children}
		</CruiseSearchContextProvider>
	);
};
